<template>
  <Sider breakpoint="md" style="height: 100%;width: 150px;background: #535A6C;">
    <Layout>
      <Header style="padding-left: 20px;">
        <div class="back-home font-cursor-pointer" @click="backIndex()">
          <Icon type="md-home" :size="24"></Icon>
          <span>{{ $t('fan-hui-shou-ye') }}</span>
        </div>
      </Header>
    </Layout>
    <Spin fix v-if="loading" class="spin-dark"></Spin>
    <Menu ref="side_menu" v-if="data.length && !loading" :active-name="activeName" :open-names="openNames" class="scrollable-menu" theme="dark" width="100%" @on-select="menuChange">
      <div v-for="(item,index) in data" :key="index">
        <template v-if="item.children">
          <Submenu :name="item.code">
            <template #title>
              <div style="width: 24px; height: 0px; display: inline-block;"></div>
              <span class="menu-title">{{ item.title }}</span>
            </template>
            <MenuItem :name="child.path" :to="'/admin'+child.path" v-for="(child,indexs) in item.children" :key="indexs">
              <div style="width: 24px; height: 0px; display: inline-block;"></div>
              <span class="menu-title">{{ child.title }}</span>
            </MenuItem>
          </Submenu>
        </template>
        <template v-else>
          <MenuItem :name="item.path" :to="'/admin'+item.path">
            <div style="width: 24px; height: 0px; display: inline-block;"></div>
            <span class="menu-title">{{ item.title }}</span>
          </MenuItem>
        </template>
      </div>
    </Menu>
  </Sider>
</template>

<script>
export default {
  data () {
    return {
      activeName: localStorage.getItem('institution_active_name') || '',
      openNames: JSON.parse(localStorage.getItem('institution_open_names')) || [],
      data: [],
      loading: false
    }
  },
  mounted () {
    // 检查当前路由是否是场景路由，如果是则从URL获取sceneId
    const currentPath = this.$route.path
    if (currentPath.startsWith('/admin/institution/scene/')) {
      const sceneIdMatch = currentPath.match(/\/admin\/institution\/scene\/(\d+)/)
      if (sceneIdMatch && sceneIdMatch[1]) {
        const sceneId = parseInt(sceneIdMatch[1])
        const currentSceneId = this.$store.state.selectedSceneId ? parseInt(this.$store.state.selectedSceneId) : null
        if (currentSceneId !== sceneId) {
          this.$store.dispatch('setSelectedSceneId', sceneId)
          this.$nextTick(() => {
            this.init()
          })
        } else {
          this.init()
        }
      } else {
        this.init()
      }
    } else {
      // 如果不是场景路由，但如果有selectedSceneId（从localStorage恢复的），也应该加载菜单
      const savedSceneId = localStorage.getItem('SELECTED_SCENE_ID')
      if (savedSceneId && !this.$store.state.selectedSceneId) {
        const sceneId = parseInt(savedSceneId)
        if (!isNaN(sceneId)) {
          this.$store.dispatch('setSelectedSceneId', sceneId)
          this.$nextTick(() => {
            this.init()
          })
          return
        }
      }
      this.init()
    }
  },
  computed: {
    selectedSceneId () {
      return this.$store.state.selectedSceneId
    }
  },
  watch: {
    selectedSceneId: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.resetMenuState()
          this.init()
        }
      }
    },
    $route (to, from) {
      // 路由变化时，根据当前路由恢复菜单选中状态
      if (this.data && this.data.length > 0) {
        const currentPath = to.path.replace('/admin', '')
        this.setMenuStateByRoute(currentPath)
      }
      // 如果是场景路由，确保菜单已加载
      if (to.path.startsWith('/admin/institution/scene/')) {
        const sceneIdMatch = to.path.match(/\/admin\/institution\/scene\/(\d+)/)
        if (sceneIdMatch && sceneIdMatch[1]) {
          const sceneId = parseInt(sceneIdMatch[1])
          if (this.$store.state.selectedSceneId !== sceneId) {
            this.$store.dispatch('setSelectedSceneId', sceneId)
          }
          // 如果菜单未加载，重新加载
          if (this.data.length === 0 && this.selectedSceneId) {
            this.init()
          }
        }
      } else {
        // 如果不是场景路由，但如果有 savedSceneId 且菜单未加载，尝试恢复并加载菜单
        const savedSceneId = localStorage.getItem('SELECTED_SCENE_ID')
        if (savedSceneId && !this.$store.state.selectedSceneId) {
          const sceneId = parseInt(savedSceneId)
          if (!isNaN(sceneId)) {
            this.$store.dispatch('setSelectedSceneId', sceneId)
            if (this.data.length === 0) {
              this.$nextTick(() => {
                this.init()
              })
            }
          }
        } else if (savedSceneId && this.$store.state.selectedSceneId && this.data.length === 0) {
          this.init()
        }
      }
    }
  },
  methods: {
    init () {
      if (this.selectedSceneId) {
        this.initSceneMenu()
      } else {
        this.data = []
      }
    },

    initSceneMenu () {
      if (!this.$store.state.insInfo || !this.$store.state.insInfo.id) {
        this.data = []
        this.loading = false
        return
      }

      this.loading = true
      this.requestApi('/adm/getInstitutionSceneMenus', {
        scene_id: this.selectedSceneId,
        ins_id: this.$store.state.insInfo.id
      }).then((res) => {
        this.loading = false
        if (res.status && res.data) {
          this.data = res.data.menus || []
          const firstRoute = res.data.firstRoute

          // 检查当前路由是否是场景路由本身
          const currentPath = this.$route.path.replace('/admin', '')
          const isSceneRoute = this.$route.path.startsWith('/admin/institution/scene/')

          // 如果当前路由在菜单中存在，恢复菜单选中状态（用于刷新浏览器后保持选中状态）
          const currentRouteInMenu = this.findRouteInMenu(this.data, currentPath)
          if (currentRouteInMenu) {
            this.setMenuStateByRoute(currentPath)
          } else if (firstRoute && isSceneRoute) {
            // 如果是场景路由本身但没有匹配的菜单项，跳转到第一个路由
            this.setMenuStateByRoute(firstRoute)
            this.$nextTick(() => {
              this.toUrl(firstRoute)
            })
          } else if (!this.activeName && firstRoute) {
            // 如果没有选中菜单且有第一个路由，设置默认状态并跳转
            this.setMenuStateByRoute(firstRoute)
            this.$nextTick(() => {
              this.toUrl(firstRoute)
            })
          } else if (!this.activeName) {
            // 没有第一个路由，只设置默认状态
            this.setDefaultMenuState()
          } else {
            // 已经有选中菜单，只更新UI
            this.updateMenuUI()
          }
        } else {
          this.data = []
        }
      }).catch((err) => {
        this.loading = false
        this.data = []
      })
    },

    setMenuStateByRoute (routePath) {
      const route = this.findRouteInMenu(this.data, routePath)
      if (route) {
        if (route.parentCode) {
          this.openNames = [route.parentCode]
          this.activeName = routePath
        } else {
          this.activeName = routePath
          this.openNames = []
        }

        localStorage.setItem('institution_open_names', JSON.stringify(this.openNames))
        localStorage.setItem('institution_active_name', this.activeName)

        this.$nextTick(() => {
          this.updateMenuUI()
        })
      }
    },

    findRouteInMenu (menuTree, targetPath) {
      for (const menu of menuTree) {
        if (menu.path === targetPath) {
          return {
            path: menu.path,
            parentCode: null
          }
        }

        if (menu.children) {
          for (const child of menu.children) {
            if (child.path === targetPath) {
              return {
                path: child.path,
                parentCode: menu.code
              }
            }
          }
        }
      }
      return null
    },

    setDefaultMenuState () {
      if (this.activeName || !this.data.length) {
        return
      }

      const firstRoute = this.findFirstRoute(this.data)
      if (firstRoute) {
        this.setMenuStateByRoute(firstRoute)
      }
    },

    findFirstRoute (menuTree) {
      for (const menu of menuTree) {
        if (menu.children && menu.children.length > 0) {
          const route = this.findFirstRoute(menu.children)
          if (route) return route
        } else if (menu.path) {
          return menu.path
        }
      }
      return null
    },

    resetMenuState () {
      this.activeName = ''
      this.openNames = []
      localStorage.removeItem('institution_active_name')
      localStorage.removeItem('institution_open_names')
    },

    updateMenuUI () {
      if (this.$refs.side_menu) {
        this.$refs.side_menu.openNames = this.openNames
        this.$refs.side_menu.activeName = this.activeName
        this.$refs.side_menu.updateOpened()
        this.$refs.side_menu.updateActiveName()
      }
    },
    // 选中路由
    menuChange (e) {
      localStorage.setItem('institution_active_name', e)
      this.activeName = e
      this.updateOpenNames()
    },
    updateOpenNames () {
      const findParent = (items, targetId) => {
        for (const item of items) {
          if (item.children && item.children.some(child => child.path === targetId)) {
            return item.code
          }
          if (item.children) {
            const parentId = findParent(item.children, targetId)
            if (parentId) {
              return parentId
            }
          }
        }
      }

      const parentId = findParent(this.data, this.activeName)
      if (parentId) {
        this.openNames = [parentId]
        localStorage.setItem('institution_open_names', JSON.stringify([parentId]))
      }
    },
    backIndex () {
      this.resetMenuState()
      this.$store.dispatch('setSelectedSceneId', null)
      this.toUrl('/institution?id=' + this.$store.state.insInfo.id)
    }
  }
}
</script>

<style scoped>
/* 隐藏滚动条但保留滚动功能 */
.scrollable-menu {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE/Edge */

  &::-webkit-scrollbar {
    display: none;
    /* Chrome/Safari/Opera */
    width: 0;
    height: 0;
    background: transparent;
  }
}

/* 其他保持滚动的核心样式 */

.scrollable-menu {
  height: calc(100vh - 64px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* 流畅滚动 */
}
.back-home {
  color: #fff;
  font-size: 18px;
}
.menu-title {
  display: inline-block;
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.spin-dark {
  background: rgba(83, 90, 108, .8);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/menu/institutionMenu.vue